import React, { FC, useRef } from 'react'
import styled from 'styled-components'

import CollapsibleForm from '../CollapsibleForm'
import { ModalContent, ModalFooter, ModalFooterButton } from './styles'
import JsonEditor from '../JsonEditor'
import { toastNotifyInvalidJsonError } from '../../lib/feedbotToast/generalImplementations'
import { SettingsPopupProps } from './SettingsPopup'

export const FormSection: FC<SettingsPopupProps> = props => {
  const submitButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <ModalContent>
        {props?.renderAboveForm}

        <CollapsibleForm
          {...props}
          onSubmit={({ formData }) => props.save(formData)}
          submitButtonRef={submitButtonRef}
        />

        {props?.renderBelowForm}
      </ModalContent>

      <ModalFooter>
        {props.footerContent}

        <ModalFooterButton
          label="Close"
          className="e2e-close-bot-modal-button"
          onClick={props.close}
        />

        <ModalFooterButton
          emphasis="primary"
          label="Save"
          className="e2e-modal-success-button"
          onClick={() => submitButtonRef.current?.click?.()}
        />
      </ModalFooter>
    </>
  )
}

export const JsonSection: FC<SettingsPopupProps> = props => {
  const jsonEditorRef = useRef<JsonEditor>(null)

  const format = () => jsonEditorRef.current?.format?.()

  const save = () => {
    const settings = jsonEditorRef.current?.getValue?.()

    if (!settings) {
      return toastNotifyInvalidJsonError()
    }

    props.save(settings)
  }

  return (
    <>
      <ModalContentWithoutPadding>
        <JsonEditor
          ref={jsonEditorRef}
          editorValue={props.formData}
          initialEditorValue={props.initialFormData}
          onChange={props.onChange}
        />
      </ModalContentWithoutPadding>

      <ModalFooter>
        {props.footerContent}

        <ModalFooterButton onClick={format} label="Format" />

        <ModalFooterButton
          label="Close"
          className="e2e-close-bot-modal-button"
          onClick={props.close}
        />

        <ModalFooterButton
          emphasis="primary"
          label="Save"
          className="e2e-modal-success-button"
          onClick={save}
        />
      </ModalFooter>
    </>
  )
}

const ModalContentWithoutPadding = styled(ModalContent)`
  padding: unset;
`
